import { ReactElement } from 'react'
import styled from 'styled-components'
import { InstitueActionProps } from './typings'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Icon } from '../../../../components'

export const TableRow = styled.tr`
  vertical-align: baseline;
`

const InstituteActionWrapper = styled.div`
  display: flex;
`

export const InstituteAction = ({
  handleView,
  handleEdit,
  handleDelete
}: InstitueActionProps): ReactElement => {
  return (
    <InstituteActionWrapper>
      <Icon variant="outline-light" onClick={handleDelete}>
        <FontAwesomeIcon
          icon={['far', 'trash-alt']}
          style={{ marginRight: 10 }}
        />
      </Icon>
      <Icon variant="outline-light" onClick={handleView}>
        <FontAwesomeIcon icon={['far', 'eye']} style={{ marginRight: 10 }} />
      </Icon>
      <Icon variant="outline-light" onClick={handleEdit}>
        <FontAwesomeIcon icon={['far', 'edit']} style={{ marginRight: 10 }} />
      </Icon>
    </InstituteActionWrapper>
  )
}
